import keyMirror from 'keymirror';
export default keyMirror({
  SETTINGS_LOAD_SUCCESS: null,
  SETTINGS_LOAD_FAIL: null,
  SETTINGS_LOADING: null
});